import { render, staticRenderFns } from "./ForumsView.vue?vue&type=template&id=b8448d22&scoped=true&"
import script from "./ForumsView.vue?vue&type=script&lang=js&"
export * from "./ForumsView.vue?vue&type=script&lang=js&"
import style0 from "./ForumsView.vue?vue&type=style&index=0&id=b8448d22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8448d22",
  null
  
)

export default component.exports